module.exports = __webpack_public_path__ + "img/arrow-up.26f7c1af.svg";